import virApis from '../../../services/api/virApis';

const ApiPaths = {
    VIR: 'vir',
};

const VirStatus = {
    Loading: "Loading",
    Valid: "Valid",
    Invalid: "Invalid",
    InvalidRegister: "InvalidRegister",
    FailedId: "FailedId",
}

/* Service class used to perform api calls for messaging */
class VirServices {

    /**
    * Is the VIR params valid
    * @param {Function} handleUnauthorized
    * @param {string} params
    */
    async getVirValid(handleUnauthorized, params) {
        let response = await virApis.create(handleUnauthorized).getVir(params);
        if (response && response.status === 200) {
            if (response.data) {
                return VirStatus.Valid;
            } else {
                return VirStatus.FailedId;
            }
        } else if (response && response.status === 400) {
            return VirStatus.Invalid;
        }

        return VirStatus.InvalidRegister;
    }

    /**
    * Accept the VIR
    * @param {Function} handleUnauthorized
    * @param {string} lang
    * @param {string} params
    */
    async updateVirAccepted(handleUnauthorized, lang, params) {
        let response = await virApis.create(handleUnauthorized).updateVir(params, lang);
        if (response && response.status === 200) {
            return true;
        } else if (response && response.status === 400) {
            console.log(response.data)
            throw new Error(response.data);
        } else if (response && response.status === 500) {
            console.log(response.data)
            throw new Error(response.data);
        }

        return false;
    }
}

const virServices = new VirServices();
export default virServices;
export { VirStatus };